export default "__VITE_ASSET__jgdswDY1__"